import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import Breadcrumbs from '../../../components/Breadcrumbs';
import { Formik } from 'formik';
import * as yup from 'yup';
import pricingValidation from "../../../../components/modals/add-new-application-modal/pricing-validation";
import Pricing from "../../create-app/components/pricing";
import Equipments from "../../create-app/components/equipments";
import Details from "../../create-app/components/details";
import Cost from "../../create-app/components/cost";
import TextInput from '../../../components/form/text-input';
import Button from '../../../components/new-button';
import Select from '../../../components/form/select';
import {
  contactInfoSchema,
  detailsInfoSchema,
  equipmentSchema,
  pricingInfoSchema,
  processorInfoSchema,
  getDefaultFees,
  templateFormSchema
} from "../../create-app/validation-schema";

import { GetMccList, getEmsOfficesById, saveTemplateV2, getTemplateById } from '../../../../api';
import { withRouter } from 'react-router-dom';
import { toast, ToastBar, Toaster } from "react-hot-toast";

const formSchema = yup.object({
  ...templateFormSchema.fields,
  ...pricingInfoSchema.fields,
  ...equipmentSchema,
  ...detailsInfoSchema.fields,
  ...processorInfoSchema,
});

let dual_pricing_validation = pricingValidation.pricingValidation.dual_pricing;
const surcharge_validation = pricingValidation.pricingValidation.surcharge;
const flat_rate_validation = pricingValidation.pricingValidation.flat_rate;
const ic_plus_validation = pricingValidation.pricingValidation.ic_plus;
const tiered_validation = pricingValidation.pricingValidation.tiered;

const pricingInfoFields = [
  "pricing_model",
  "dual_pricing_rate",
  "dual_pricing_monthly_fee",
  "surcharge_rate",
  "surcharge_per_transaction",
  "surcharge_monthly_fee",
  "flat_rate",
  "flat_rate_transaction",
  "flat_rate_amex",
  "flat_rate_amex_transaction",
  "ic_plus_rate",
  "ic_plus_transaction_fee",
  "ic_plus_amex_rate",
  "ic_plus_amex_transaction_fee",
  "tiered_qual_rate",
  "tiered_qual_transaction",
  "tiered_qual_debit_rate",
  "tiered_qual_debit_per_transaction",
  "tiered_mid_qual_rate",
  "tiered_mid_qual_transaction",
  "tiered_mid_qual_debit_rate",
  "tiered_mid_qual_debit_per_transaction",
  "tiered_non_qual_rate",
  "tiered_non_qual_transaction",
  "tiered_non_qual_debit_rate",
  "tiered_non_qual_debit_per_transaction",
  "tiered_amex_structure",
  "amex_tier_one_rate",
  "amex_tier_one_fee",
  "amex_tier_two_rate",
  "amex_tier_two_fee",
  "amex_tier_three_rate",
  "amex_tier_three_fee",
  "amex_tier_four_rate",
  "amex_tier_four_fee",
  "tiered_amex_flat_rate",
  "tiered_amex_flat_transaction",
  "tiered_amex_ic_plus_rate",
  "tiered_amex_ic_plus_transaction",
  "pin_debit_network_fee",
  "debit_rate",
  "debit_per_txn",
  "ebt",
  "fnf_number",
  "ebt_transactions",
  "var_sheet_request",
  // "reprogram_hardware",
  // "use_existing_gateway",
  // "existing_gateway",
  "var_only",
];

const detailsInfoField = [
  "who_to_deploy_equipment",
  "who_to_pay_for_equipment",
  "who_to_deploy_gateway",
  "billing_sequence",
  "cover_cancellation",
  "reimbursement_maximum",
  "expedited_funding",
  "batch_time",
  "equipment_address",
  "invoice_address",
  // "special_instructions",
];

const CreateTemplate = ({ match, history }) => {
  const breadcrumbItems = [
    { label: "Templates", to: "/v2/templates" },
    { label: "Create Template Pricing + Equipment" }
  ];

  const templateId = match.params.id;
  useEffect(() => {
    if (templateId) {
      getTemplateById(templateId).then(res => {
        console.log('res templateId', res)
        if (res.status) {
          console.log('res.data', res.data)
          setFormData({ 
            ...res?.data?.data,
            var_only: res?.data?.data?.var_only && res?.data?.data?.var_only?.length > 0 ? JSON.parse(res?.data?.data?.var_only) : {},
          })
        }
      })
    }
  }, [templateId])

  const [openSections, setOpenSections] = useState({
    contact: true,
    pricing: true,
    equipments: true,
    details: true,
    processors: true,
  });

  const [mccList, setMccList] = useState([]);
  const [emsOfficeList, setEmsOfficeList] = useState([]);

  useEffect(() => {

    GetMccList().then((res) => {
      if (res.success) {
        let mccList = res.data.map(item => ({
          label: item.description,
          value: item.id
        }));

        setMccList(mccList);
      }
    });

    getEmsOfficesById().then(response => {
      if (response.status) {
        setEmsOfficeList(response.data);
      }
    });

  }, []);

  const defaultFees = getDefaultFees(1);

  const [formData, setFormData] = useState(
    {
      // template form fields
      name: "",
      mcc_id: "",
      ems_office_id: "",

      // pricing fields
      pricing_model: "dual_pricing",
      // Dual pricing fields
      dual_pricing_rate: dual_pricing_validation.dual_pricing_rate.default,
      dual_pricing_monthly_fee:
        dual_pricing_validation.dual_pricing_monthly_fee.default.toFixed(2),

      // surcharge
      surcharge_rate: surcharge_validation.surcharge_rate.default.toFixed(2),
      surcharge_per_transaction:
        surcharge_validation.surcharge_per_transaction.default.toFixed(2),
      surcharge_monthly_fee:
        surcharge_validation.surcharge_monthly_fee.default.toFixed(2),

      // Flat Rate
      flat_rate: flat_rate_validation.flat_rate.default.toFixed(2),
      flat_rate_transaction:
        flat_rate_validation.flat_rate_transaction.default.toFixed(2),
      flat_rate_amex: flat_rate_validation.flat_rate_amex.default.toFixed(2),
      flat_rate_amex_transaction:
        flat_rate_validation.flat_rate_amex_transaction.default.toFixed(2),

      // IC+
      ic_plus_rate: ic_plus_validation.ic_plus_rate.default.toFixed(2),
      ic_plus_transaction_fee:
        ic_plus_validation.ic_plus_transaction_fee.default.toFixed(2),
      ic_plus_amex_rate: ic_plus_validation.ic_plus_amex_rate.default.toFixed(2),
      ic_plus_amex_transaction_fee:
        ic_plus_validation.ic_plus_amex_transaction_fee.default.toFixed(2),

      // tiered
      tiered_qual_rate: tiered_validation.tiered_qual_rate.default.toFixed(2),
      tiered_qual_transaction:
        tiered_validation.tiered_qual_transaction.default.toFixed(2),
      tiered_qual_debit_rate:
        tiered_validation.tiered_qual_debit_rate.default.toFixed(2),
      tiered_qual_debit_per_transaction:
        tiered_validation.tiered_qual_debit_per_transaction.default.toFixed(2),

      tiered_mid_qual_rate:
        tiered_validation.tiered_mid_qual_rate.default.toFixed(2),
      tiered_mid_qual_transaction:
        tiered_validation.tiered_mid_qual_transaction.default.toFixed(2),
      tiered_mid_qual_debit_rate:
        tiered_validation.tiered_mid_qual_debit_rate.default.toFixed(2),
      tiered_mid_qual_debit_per_transaction:
        tiered_validation.tiered_mid_qual_debit_per_transaction.default.toFixed(
          2,
        ),

      tiered_non_qual_rate:
        tiered_validation.tiered_non_qual_rate.default.toFixed(2),
      tiered_non_qual_transaction:
        tiered_validation.tiered_non_qual_transaction.default.toFixed(2),
      tiered_non_qual_debit_rate:
        tiered_validation.tiered_non_qual_debit_rate.default.toFixed(2),
      tiered_non_qual_debit_per_transaction:
        tiered_validation.tiered_non_qual_debit_per_transaction.default.toFixed(
          2,
        ),

      tiered_amex_structure: "flat_rate", // tiered, flat_rate, ic_plus

      amex_tier_one_rate: tiered_validation.amex_tier_one_rate.default.toFixed(2),
      amex_tier_one_fee: tiered_validation.amex_tier_one_fee.default.toFixed(2),
      amex_tier_two_rate: tiered_validation.amex_tier_two_rate.default.toFixed(2),
      amex_tier_two_fee: tiered_validation.amex_tier_two_fee.default.toFixed(2),
      amex_tier_three_rate:
        tiered_validation.amex_tier_three_rate.default.toFixed(2),
      amex_tier_three_fee:
        tiered_validation.amex_tier_three_fee.default.toFixed(2),
      amex_tier_four_rate:
        tiered_validation.amex_tier_four_rate.default.toFixed(2),
      amex_tier_four_fee: tiered_validation.amex_tier_four_fee.default.toFixed(2),

      tiered_amex_flat_rate:
        tiered_validation.tiered_amex_flat_rate.default.toFixed(2),
      tiered_amex_flat_transaction:
        tiered_validation.tiered_amex_flat_transaction.default.toFixed(2),

      tiered_amex_ic_plus_rate:
        tiered_validation.tiered_amex_ic_plus_rate.default.toFixed(2),
      tiered_amex_ic_plus_transaction:
        tiered_validation.tiered_amex_ic_plus_transaction.default.toFixed(2),

      // pin based debit
      pin_debit_network_fee: "yes",
      debit_rate: "2.00",
      debit_per_txn: "0.15",

      //Note: Below field is not used anywhere, but kept so as not to break anything.
      monthly_fee: "49.00",

      // ebt
      ebt: "no",
      fnf_number: "",

      // other default fees
      ...Object.keys(defaultFees).reduce((acc, key) => {
        acc[key] = defaultFees[key].default.toFixed(2);
        return acc;
      }, {}),

      var_only: {},

      equipments: [],
      other_gateway: "",

      // details
      who_to_deploy_equipment: "",
      who_to_pay_for_equipment: "",
      who_to_deploy_gateway: "",
      billing_sequence: "daily",
      cover_cancellation: "no",
      reimbursement_maximum: "",
      expedited_funding: "no",
      batch_time: "06:00 PM",
      equipment_address: "dba_address",
      invoice_address: "agent_address",
      special_instructions: "",
    }
  );

  const onSubmit = async (
    values,
    { setTouched, setSubmitting, errors, setErrors, touched },
  ) => {

    const toastId = toast.loading('Saving template...', {
      duration: 10000,
    });

    try {
      setSubmitting(true);
      const submitData = {
        ...values,
        id: templateId ? templateId : null,
      }
      const res = await saveTemplateV2(submitData);

      if (res.status) {
        toast.success('Template saved successfully', {
          id: toastId,
        });
        history.push(`/v2/templates`);
      } else {
        // Handle API error response
        const errorMessage = res.message || 'Failed to save template';
        toast.error(errorMessage);

        // If there are validation errors from the API, set them
        if (res.errors) {
          setErrors(res.errors);
          // Mark all error fields as touched to show validation messages
          const touchedFields = Object.keys(res.errors).reduce((acc, key) => {
            acc[key] = true;
            return acc;
          }, {});
          setTouched(touchedFields);
        }
      }
    } catch (error) {
      console.error('Error saving template:', error);
      toast.error('An unexpected error occurred while saving the template');
    } finally {
      setSubmitting(false);
    }
  }


  return (
    <div className={styles.pageWrapper}>
      <Breadcrumbs items={breadcrumbItems} />

      <h1 className={styles.title}>Create Pricing + Equipment Template</h1>

      <Formik
        enableReinitialize
        validationSchema={formSchema}
        onSubmit={onSubmit}
        initialValues={formData}
        validateOnBlur={true}
        validateOnChange={true}
      >
        {({ handleSubmit, values, errors, touched, isSubmitting, handleChange, handleBlur, setFieldValue }) => (

          <div className={styles.content}>
            {console.log('errors', errors)}
            <div className={styles.left}>
              <form
                className={styles.form}
                onSubmit={handleSubmit}
              >

                <div className={styles.card}>
                  <div className={`${styles.grid} ${styles.gridCol1} ${styles.w100}`} >
                    <TextInput
                      label="Template Name"
                      name="name"
                      placeholder="Template Name"
                      onChange={handleChange}
                      value={values.name}
                      onBlur={handleBlur}
                      touched={touched.name}
                      errored={errors.name}
                      error={errors.name}
                    />
                  </div>

                  <div className={`${styles.grid} ${styles.gridCol2} ${styles.w100} ${styles.gap1}`} >
                    <Select
                      label="MCC ID"
                      name="mcc_id"
                      placeholder="Select MCC ID"
                      options={mccList}
                      onChange={(value) => {
                        console.log('value', value)
                        setFieldValue('mcc_id', value)
                      }}
                      value={values.mcc_id}
                      onBlur={handleBlur}
                      touched={touched.mcc_id}
                      errored={errors.mcc_id}
                      error={errors.mcc_id}
                    />

                    <Select
                      label="EMS Office ID"
                      name="ems_office_id"
                      placeholder="Select EMS Office ID"
                      options={emsOfficeList}
                      onChange={(value) => {
                        console.log('value', value)
                        setFieldValue('ems_office_id', value)
                      }}
                      value={values.ems_office_id}
                      onBlur={handleBlur}
                      touched={touched.ems_office_id}
                      errored={errors.ems_office_id}
                      error={errors.ems_office_id}
                    />
                  </div>
                </div>

                <Pricing
                  pricingInfoFields={pricingInfoFields}
                  isOpen={openSections.pricing}
                  onToggle={() =>
                    setOpenSections((prev) => ({
                      ...prev,
                      pricing: !prev.pricing,
                    }))
                  }
                />

                <Equipments
                  isOpen={openSections.equipments}
                  onToggle={() =>
                    setOpenSections((prev) => ({
                      ...prev,
                      equipments: !prev.equipments,
                    }))
                  }
                />

                <Details
                  detailsInfoField={detailsInfoField}
                  isOpen={openSections.details}
                  onToggle={() =>
                    setOpenSections((prev) => ({
                      ...prev,
                      details: !prev.details,
                    }))
                  }
                />


                <div className={styles.buttons}>
                  <Button variant='ghost'>
                    Cancel
                  </Button>

                  <Button
                    variant='primary'
                    type='submit'
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Saving...' : 'Save'}
                  </Button>
                </div>

              </form>
            </div>
            <div className={styles.right}>
              <Cost />
            </div>
          </div>
        )}
      </Formik>


      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button
                    className={styles.toast_dismissal_button}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M12.8535 12.1462C12.9 12.1927 12.9368 12.2478 12.962 12.3085C12.9871 12.3692 13.0001 12.4343 13.0001 12.5C13.0001 12.5657 12.9871 12.6307 12.962 12.6914C12.9368 12.7521 12.9 12.8073 12.8535 12.8537C12.8071 12.9002 12.7519 12.937 12.6912 12.9622C12.6305 12.9873 12.5655 13.0003 12.4998 13.0003C12.4341 13.0003 12.369 12.9873 12.3083 12.9622C12.2476 12.937 12.1925 12.9002 12.146 12.8537L7.99979 8.70685L3.85354 12.8537C3.75972 12.9475 3.63247 13.0003 3.49979 13.0003C3.36711 13.0003 3.23986 12.9475 3.14604 12.8537C3.05222 12.7599 2.99951 12.6327 2.99951 12.5C2.99951 12.3673 3.05222 12.24 3.14604 12.1462L7.29291 7.99997L3.14604 3.85372C3.05222 3.7599 2.99951 3.63265 2.99951 3.49997C2.99951 3.36729 3.05222 3.24004 3.14604 3.14622C3.23986 3.0524 3.36711 2.99969 3.49979 2.99969C3.63247 2.99969 3.75972 3.0524 3.85354 3.14622L7.99979 7.2931L12.146 3.14622C12.2399 3.0524 12.3671 2.99969 12.4998 2.99969C12.6325 2.99969 12.7597 3.0524 12.8535 3.14622C12.9474 3.24004 13.0001 3.36729 13.0001 3.49997C13.0001 3.63265 12.9474 3.7599 12.8535 3.85372L8.70666 7.99997L12.8535 12.1462Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  )
}

export default withRouter(CreateTemplate);